const MixMaxPrivacyPolicy = ({ appName = "Mix Max" }) => {
  return (
    <div id="content">
      <p>
        {`My Fortuna LLC built the ${appName} app as a Commercial app. This SERVICE is provided by My Fortuna LLC and is intended
          for use as is. `}
      </p>
      <p>
        {" "}
        This page is used to inform visitors regarding our policies with the
        collection, use, and disclosure of Personal Information if anyone
        decided to use our Service.
      </p>
      <p>
        {" "}
        If you choose to use our Service, then you agree to the collection and
        use of information in relation to this policy. The Personal Information
        that we collect is used for providing and improving the Service. We will
        not use or share your information with anyone except as described in
        this Privacy Policy.
      </p>
      <p>{` The terms used in this Privacy
        Policy have the same meanings as in our Terms and Conditions, which are accessible at ${appName} unless otherwise
        defined in this Privacy Policy. `}</p>

      <p>
        <strong>Information Collection and Use</strong>
      </p>
      <p>
        {`The only piece of personally identifiable information that ${appName}
        knowingly collects is your email address, and we collect it only when
        you choose to sign in with a third-party provider (such as Google or
        Apple). You may also use the app as a guest, in which case no email
        address is collected. `}
      </p>
      <p>
        {`We collect your email address for one purpose only: to create, secure
        and process your account, and to identify you as the owner of that
        account and the experiments and data stored within it. Under the EU
        General Data Protection Regulation (GDPR), the lawful basis for this
        processing is Article 6(1)(b) — processing necessary for the performance
        of the contract we enter into with you when you create an account and
        use the Service. `}
      </p>
      <p>
        {`Your email address is not used for any other purpose. We do not use it
        for advertising or profiling, we do not sell it, and we do not share it
        with third parties for their own purposes. `}
      </p>

      <p>
        <strong>User Content and Prohibited Information</strong>
      </p>
      <p>
        {`${appName} lets you create and customize experiments using freeform
        fields that you fill in yourself — for example experiment names,
        parameter names, units, choices and labels, and outcome names and
        descriptions. This content is stored to provide the Service. `}
      </p>
      <p>
        {`These freeform fields are intended for describing experiments only. You
        must not enter any personally identifiable information — your own or
        anyone else's — into them. This includes, but is not limited to, names,
        email addresses, phone numbers, postal addresses, government or
        financial identifiers, health information, or any other information that
        could identify a person. We neither request nor require such information
        in these fields, and any content you enter there is treated as
        non-personal experiment data. If you do enter personal information into
        these fields contrary to this policy and our Terms of Service, you are
        responsible for it, and you may remove it at any time by editing or
        deleting the relevant experiment. `}
      </p>

      <div>
        <p>
          {" "}
          The app does use third-party services that may collect information
          used to identify you.{" "}
        </p>
        <p>
          {" "}
          Link to the privacy policy of third-party service providers used by
          the app
        </p>
        <ul>
          <li>
            <a
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play Services
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/policies/analytics"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Analytics for Firebase
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/support/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Firebase Crashlytics
            </a>
          </li>
        </ul>
      </div>
      <p>
        <strong>Log Data</strong>
      </p>
      <p>
        {" "}
        We want to inform you that whenever you use our Service, in a case of an
        error in the app we collect data and information (through third-party
        products) on your phone called Log Data. This Log Data may include
        information such as your device Internet Protocol (“IP”) address, device
        name, operating system version, the configuration of the app when
        utilizing our Service, the time and date of your use of the Service, and
        other statistics.{" "}
      </p>
      <p>
        {`We use Google Analytics for Firebase and Firebase Crashlytics to
        understand how the app is used and to diagnose crashes so we can keep
        ${appName} working reliably. For crash reporting, your account's internal
        identifier (not your email address) may be attached to a crash report so
        we can investigate the issue. This diagnostic data is processed on our
        behalf and is not used to advertise to you. `}
      </p>
      <p>
        <strong>Cookies</strong>
      </p>
      <p>
        {" "}
        Cookies are files with a small amount of data that are commonly used as
        anonymous unique identifiers. These are sent to your browser from the
        websites that you visit and are stored on your device's internal memory.{" "}
      </p>
      <p>
        {" "}
        This Service does not use these “cookies” explicitly. However, the app
        may use third-party code and libraries that use “cookies” to collect
        information and improve their services. You have the option to either
        accept or refuse these cookies and know when a cookie is being sent to
        your device. If you choose to refuse our cookies, you may not be able to
        use some portions of this Service.{" "}
      </p>
      <p>
        <strong>Service Providers</strong>
      </p>
      <p>
        {" "}
        We may employ third-party companies and individuals (data processors)
        due to the following reasons:{" "}
      </p>

      <ul>
        <li>To facilitate our Service;</li>
        <li>To provide the Service on our behalf;</li>
        <li>To perform Service-related services; or</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ul>
      <p>
        {`Our account, database, authentication, crash-reporting and analytics
        functions are provided by Google Firebase, which acts as a data
        processor and stores your account and experiment data on our behalf.
        These providers may have access to the information needed to perform
        their tasks for us, but they are obligated not to disclose or use it for
        any other purpose. We do not sell your personal data, and we do not share
        your email address with third parties for their own purposes. `}
      </p>
      <p>
        <strong>Your Data Protection Rights (GDPR)</strong>
      </p>
      <p>
        {`If you are located in the European Economic Area or the United Kingdom,
        you have rights over the personal data we hold about you. These include
        the right to access your data, to correct it, to erase it, to restrict
        or object to its processing, and to data portability. `}
      </p>
      <p>
        {`You can delete your account at any time from within ${appName}. Deleting
        your account permanently removes your account record, your email address
        and every experiment and run associated with it. You may also exercise
        any of your rights, or ask any question about how we handle your data, by
        contacting us at support@myfortuna.app. You also have the right to lodge
        a complaint with your local data protection authority. `}
      </p>
      <p>
        <strong>Data Retention</strong>
      </p>
      <p>
        {`We retain your email address and experiment data for as long as your
        account remains active so we can provide the Service. When you delete
        your account, this data is deleted. `}
      </p>
      <p>
        <strong>Security</strong>
      </p>
      <p>
        {" "}
        We value your trust in providing us your Personal Information, thus we
        are striving to use commercially acceptable means of protecting it. But
        remember that no method of transmission over the internet, or method of
        electronic storage is 100% secure and reliable, and we cannot guarantee
        its absolute security.{" "}
      </p>
      <p>
        <strong>Links to Other Sites</strong>
      </p>
      <p>
        {" "}
        This Service may contain links to other sites. If you click on a
        third-party link, you will be directed to that site. Note that these
        external sites are not operated by us. Therefore, we strongly advise you
        to review the Privacy Policy of these websites. We have no control over
        and assume no responsibility for the content, privacy policies, or
        practices of any third-party sites or services.{" "}
      </p>
      <p>
        <strong>Children’s Privacy</strong>
      </p>
      <div>
        <p>
          {` These Services are not directed to children under the age of 13, and
          we do not normally or knowingly collect personally identifiable
          information from children under 13 years of age. In the case we
          discover that a child under 13 has provided us with personal
          information, we immediately delete this from our servers. If you are a
          parent or guardian and you are aware that your child has provided us
          with personal information, please contact us so that we will be able to
          do the necessary actions. `}
        </p>
      </div>

      <p>
        <strong>Changes to This Privacy Policy</strong>
      </p>
      <p>
        {" "}
        We may update our Privacy Policy from time to time. Thus, you are
        advised to review this page periodically for any changes. We will notify
        you of any changes by posting the new Privacy Policy on this page.{" "}
      </p>
      <p>This policy is effective as of 2026-06-14</p>
      <p>
        <strong>Contact Us</strong>
      </p>
      <p>
        {" "}
        If you have any questions or suggestions about our Privacy Policy, do
        not hesitate to contact us at support@myfortuna.app.{" "}
      </p>
    </div>
  );
};

export default MixMaxPrivacyPolicy;
